export const ONBOARDING_CHECKLIST_VERSION = "v2";
export const ONBOARDING_TOTAL_STEPS = 5;
export const ONBOARDING_STEP_IDS = [1, 2, 3, 4, 5] as const;
